import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { ProductModel } from "../../../../../main/products/api/types";

export interface IProductDropdownState {
  pageNumber: number;
  pageSize: number;
  anchorEl: null | HTMLElement;
  selected: ProductModel | undefined;
  setSelected: (val: ProductModel | undefined) => void;
  setAnchorEl: (anchorEl: null | HTMLElement) => void;
  setPageNumber: (val: number) => void;
  setPageSize: (val: number) => void;
}

const initialData = {
  pageNumber: 1,
  pageSize: 100,
  anchorEl: null,
  selected: undefined,
};

const useProductDropdownStore = create<IProductDropdownState>()(
  persist(
    (set) => ({
      ...initialData,
      setSelected: (selected) => set({ selected }),
      setAnchorEl: (anchorEl) => set({ anchorEl }),
      setPageNumber: (pageNumber) => set({ pageNumber }),
      setPageSize: (pageSize) => set({ pageSize }),
    }),
    {
      name: "product-dropdown-store",

      partialize: (state) => ({
        selected: state.selected,
        pageNumber: state.pageNumber,
        pageSize: state.pageSize,
      }),
    }
  )
);

export default useProductDropdownStore;
